// ======================================================================
// File Name       : ContentDrillEditionContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import $ from 'jquery';
import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getDrillQuestionListForSort } from '../../actions/ContentAction';
import { saveActiveTabMenu } from '../../actions/TabMenuAction';
import * as ContentAction from '../../actions/content/ContentAction';
import { getDrillDetail, updateDrill } from '../../actions/content/ContentDrillAction';
import * as ContentQuestionAction from '../../actions/content/ContentQuestionAction';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import ContentDrillEdit from '../../components/content/ContentDrillEdit';
import ContentDrillEditAdvanced from '../../components/content/ContentDrillEditAdvanced';
import ContentDrillEditConfirmDialog from '../../components/content/ContentDrillEditConfirmDialog';
import ContentDrillQuestionSortDiaLog from '../../components/content/ContentDrillQuestionSortDialog';
import AddQuestionDialog from '../../components/content/ContentDrillRegisterAddQuestion';
import * as ContentConstant from '../../constants/ContentConstant';
import * as Path from '../../constants/PathConstants';
import { CONTENT_DRILL_LIST, PREVIEW_EACH_QUESTION_ATTRIBUTE } from '../../constants/PathConstants';
import { NUM_ATTRIBUTE_QUESTION_SEARCH, NUM_ATTRIBUTE_QUESTION_SEARCH_MAX, PREVIEW_EACH_QUESTION_ATTRIBUTE_NAME } from '../../constants/index';
import { htmlEntities } from '../../utils/index';

class ContentDrillEditionContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drillDetailInfo: null,
      contentDrillEdition: null,
      showDialog: false,
      editSuccessfull: false,
      newDrillIdTemplate: {
        show: true,
        subIndex: '',
        subQuestionSecernId: '',
      },
      skinSetList: [],
      questionDataList: [],
      drillKind: '',
      drillSecernId: '',
      drillTitle: '',
      drillName: '',
      continuedFrStart: false,
      collectingLastMistakenIssue: false,
      collectingLastMistakenIssueEvenOnce: false,
      collectionQuestionsRegisteredInFavorites: false,
      scoreForm: '',
      skinSetSecernId: '',
      questionId: '',
      oldQuestionId: '',
      showAddQuestionModal: false,
      advanceButtonText: 'plus',
      restrictReanswer: false,
      limitTimeAdaptedTarget: ContentConstant.CONTENT_DRILL_OBJECT.DO_NOT_USE,
      limitTimeOverAction: '',
      limitTimeCountForm: '',
      markRule: 0,
      sankakuJudgeUseSet: true,
      attentionRelateSet: true,
      attentionHtmlUse: false,
      attentionZipFile: '',
      attentionContent: '',
      learningMeaning: '',
      price: '',
      showConfirmModal: false,
      perfectPoint: 0,
      isAdvanceClosed: true,
      drillLimitTime: '',
      reanswerTime: '',
      isFirst: true,
      sankakuMarkSet: 0,
      isEdit: false,
      attentionHtmlFileName: '',
      skinSetName: '',
      isGetDataFirstTime: true,
      isAllowShowSearchMessage: false,
      adaptiveDrillDecisionQuestionNumber: 1,
      adaptiveDrillMaxQuestionNumber: '',
      attributeOptions: {},
      attributeText: {},
      isClosed: true,
      buttonText: 'plus',
      number: NUM_ATTRIBUTE_QUESTION_SEARCH,
      showContentDrillQuestionSortDiaLog: false, // STEP9.0.0
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onAddIdAuthorityOk = this.onAddIdAuthorityOk.bind(this);
    this.deleteQuestion = this.deleteQuestion.bind(this);
    this.openAddQuestionDialog = this.openAddQuestionDialog.bind(this);
    this.dialogCancel = this.dialogCancel.bind(this);
    this.handleOpenOrCloseAdvanceSettings = this.handleOpenOrCloseAdvanceSettings.bind(this);
    this.fileChange = this.fileChange.bind(this);
    this.confirmDialogOK = this.confirmDialogOK.bind(this);
    this.onEditBtnClick = this.onEditBtnClick.bind(this);
    this.getConfirmData = this.getConfirmData.bind(this);
    this.onChange = this.onChange.bind(this);
    this.validation = this.validation.bind(this);
    this.onBackBtnClick = this.onBackBtnClick.bind(this);

    // dialog add question to drill
    this.handleDialogChange = this.handleDialogChange.bind(this);
    this.getStartEndDialogData = this.getStartEndDialogData.bind(this);
    this.handleDialogSortState = this.handleDialogSortState.bind(this);
    this.handleDialogCheckBox = this.handleDialogCheckBox.bind(this);
    this.dialogSearch = this.dialogSearch.bind(this);
    this.addQuestionDialogOK = this.addQuestionDialogOK.bind(this);
    this.dialogQuestionCancel = this.dialogQuestionCancel.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.createParams = this.createParams.bind(this);
    this.getconfirmDataAdaptive = this.getconfirmDataAdaptive.bind(this);
    this.openOrCloseAttributeArea = this.openOrCloseAttributeArea.bind(this);
    this.openPreviewEachQuestionAttribute = this.openPreviewEachQuestionAttribute.bind(this);
    this.handleChangeOption = this.handleChangeOption.bind(this);
    this.handleChangeTextAttribute = this.handleChangeTextAttribute.bind(this);
    this.addAttribute = this.addAttribute.bind(this);
    this.removeAttributeSearch = this.removeAttributeSearch.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.removeAllQuestionFromList = this.removeAllQuestionFromList.bind(this);
    this.addGroup = this.addGroup.bind(this);
    this.removeGroup = this.removeGroup.bind(this);
    this.saveActiveTabMenu = this.saveActiveTabMenu.bind(this);
    // STEP9.0.0 START
    this.openSortDrillQuestionDialog = this.openSortDrillQuestionDialog.bind(this);
    this.hideSortDrillQuestionDialog = this.hideSortDrillQuestionDialog.bind(this);
    // STEP9.0.0 END
  }

  openOrCloseAttributeArea() {
    this.setState({
      isClosed: !this.state.isClosed,
      buttonText: this.state.isClosed ? 'minute' : 'plus',
    });
  }

  handleChangeTextAttribute(event) {
    const name = event.target.name;
    const value = event.target.value;
    const attributeText = { ...this.state.attributeText, ...{ [name]: value } };
    this.setState({ attributeText });
  }

  addAttribute() {
    let number = this.state.number;
    number++;
    this.setState({
      ...this.state,
      number,
    });
  }

  openPreviewEachQuestionAttribute() {
    const newWindows = window.open(PREVIEW_EACH_QUESTION_ATTRIBUTE, PREVIEW_EACH_QUESTION_ATTRIBUTE_NAME, 'height=750,width=850');
    newWindows.focus();
  }

  handleChangeOption(event) {
    const name = event.target.name;
    const value = event.target.value;
    const nameOptions = name.split('.').pop();
    const attributeOptions = { ...this.state.attributeOptions, ...{ [nameOptions]: value } };
    let attributeText = { ...this.state.attributeText };
    if (!attributeOptions[nameOptions]) {
      attributeText = { ...this.state.attributeText, ...{ [nameOptions]: '' } };
    }
    this.setState({ attributeOptions, attributeText });
  }

  /**
   * Life cycle function
   */
  componentWillMount() {
    const { match } = this.props;
    if (match.params.id) {
      const drillSecernId = match.params.id;
      this.props.dispatch(getDrillDetail(drillSecernId));
      this.getSkinSetList();
      const cachedIframe = $('.cached_question_skin');
      if (!(cachedIframe && cachedIframe.length)) {
        ContentQuestionAction.cachePreviewQuestionSkin();
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { content, match, questionListInfo } = nextProps;
    const { drillDetailInfo, questionAddDialog, questionAddDialogArr } = content;
    const { edit } = content;
    const { questionId } = edit;
    const { oldQuestionId } = edit;
    const { skinSetList } = edit;
    if (questionId !== undefined) {
      this.setState({ questionId });
    }
    if (oldQuestionId !== undefined) {
      this.setState({ oldQuestionId });
    }
    if (content.drillDetailInfoOK) {
      this.setState({
        editSuccessfull: true,
      });
    }
    const { isGetDataFirstTime } = this.state;
    if (drillDetailInfo &&
        drillDetailInfo.drillSecernId === match.params.id &&
        isGetDataFirstTime) {
      const againLimitArray = drillDetailInfo.againLimit && drillDetailInfo.againLimit.split('_');
      let retrictReanswerTemp = false;
      let reanswerTimeTemp = '';
      if (againLimitArray) {
        switch (againLimitArray[0]) {
          case '0':
            retrictReanswerTemp = false;
            break;
          case '1':
            retrictReanswerTemp = true;
            break;
          default:
            retrictReanswerTemp = false;
        }
        reanswerTimeTemp = againLimitArray[1];
      }
      let limitTimeAdaptedTargetTemp = ContentConstant.CONTENT_DRILL_OBJECT.DO_NOT_USE;
      const limitTimeAdaptedTarget = parseInt(drillDetailInfo.limitTimeAdaptedTarget, 10);
      switch (limitTimeAdaptedTarget) {
        case 0:
          limitTimeAdaptedTargetTemp = ContentConstant.CONTENT_DRILL_OBJECT.DO_NOT_USE;
          break;
        case 1:
          limitTimeAdaptedTargetTemp = ContentConstant.CONTENT_DRILL_OBJECT.DRILL_PRIORITY;
          break;
        case 2:
          limitTimeAdaptedTargetTemp = ContentConstant.CONTENT_DRILL_OBJECT.QUESTION_PRIORITY;
          break;
        default:
          break;
      }
      const startConditionsArray = drillDetailInfo.startConditionList;
      let continuedFrStartEdit = false;
      let collectingLastMistakenIssueEdit = false;
      let collectingLastMistakenIssueEvenOnceEdit = false;
      let collectionQuestionsRegisteredInFavoritesEdit = false;
      if (startConditionsArray) {
        startConditionsArray.forEach((conditionItem) => {
          conditionItem = parseInt(conditionItem, 10);
          switch (conditionItem) {
            case 1:
              continuedFrStartEdit = true;
              break;
            case 2:
              collectingLastMistakenIssueEdit = true;
              break;
            case 3:
              collectingLastMistakenIssueEvenOnceEdit = true;
              break;
            case 4:
              collectionQuestionsRegisteredInFavoritesEdit = true;
              break;
            default:
              break;
          }
        }, this);
      }
      let scoreFormTemp = null;
      let markRuleTemp = null;
      let perfectPointTemp = null;
      let sankakuJudgeUseSetTemp = null;
      let sankakuMarkSetTemp = 0;
      let attentionRelateSetTemp = '0';
      let attentionHtmlUseTemp = 0;
      if (this.state.isFirst) {
        scoreFormTemp = drillDetailInfo.scoreForm;
        markRuleTemp = drillDetailInfo.markRule;
        perfectPointTemp = drillDetailInfo.perfectPoint;
        sankakuJudgeUseSetTemp = drillDetailInfo.sankakuJudgeUseSet;
        sankakuMarkSetTemp = drillDetailInfo.sankakuMarkSet;
        attentionRelateSetTemp = drillDetailInfo.attentionRelateSet;
        attentionHtmlUseTemp = drillDetailInfo.attentionHtmlUse;
      }
      if (attentionRelateSetTemp == '0') {
        attentionRelateSetTemp = false;
      } else {
        attentionRelateSetTemp = true;
      }
      if (attentionHtmlUseTemp === 1) {
        attentionHtmlUseTemp = true;
      } else {
        attentionHtmlUseTemp = false;
      }
      this.setState({
        drillDetailInfo,
        drillKind: drillDetailInfo.drillKind,
        drillSecernId: drillDetailInfo.drillSecernId,
        drillName: drillDetailInfo.drillTitle,
        continuedFrStart: continuedFrStartEdit,
        collectingLastMistakenIssue: collectingLastMistakenIssueEdit,
        collectingLastMistakenIssueEvenOnce: collectingLastMistakenIssueEvenOnceEdit,
        collectionQuestionsRegisteredInFavorites: collectionQuestionsRegisteredInFavoritesEdit,
        restrictReanswer: retrictReanswerTemp,
        reanswerTime: reanswerTimeTemp,
        scoreForm: scoreFormTemp,
        skinSetSecernId: drillDetailInfo.skinSetSecernId,
        limitTimeAdaptedTarget: limitTimeAdaptedTargetTemp,
        limitTimeOverAction: drillDetailInfo.limitTimeOverAction,
        limitTimeCountForm: drillDetailInfo.limitTimeCountForm,
        markRule: markRuleTemp,
        perfectPoint: perfectPointTemp,
        sankakuJudgeUseSet: sankakuJudgeUseSetTemp,
        sankakuMarkSet: sankakuMarkSetTemp,
        attentionRelateSet: attentionRelateSetTemp,
        attentionHtmlUse: attentionHtmlUseTemp,
        drillLimitTime: drillDetailInfo.drillLimitTime,
        attentionContent: drillDetailInfo.attentionContent ? htmlEntities(drillDetailInfo.attentionContent) : '', // #6952
        attentionHtmlFileName: drillDetailInfo.attentionZipFileName,
        skinSetName: drillDetailInfo.skinSetName,
        isGetDataFirstTime: !isGetDataFirstTime,
        adaptiveDrillDecisionQuestionNumber: drillDetailInfo.adaptiveDrillDecisionQuestionNumber,
        adaptiveDrillMaxQuestionNumber: drillDetailInfo.adaptiveDrillMaxQuestionNumber,
      });
    }
    if (skinSetList !== undefined) {
      this.setState({ skinSetList });
    }

    //  --- question dialog
    const { questionDataList, dialogQuestionInfo, questionDataListTemp } = questionAddDialog;

    if (dialogQuestionInfo !== undefined) {
      dialogQuestionInfo.dataAffiliationType = ContentConstant.DATA_AFFIILIATION_TYPE.INTERNAL;
      this.setState({ dialogQuestionInfo });
    }
    if (questionListInfo !== undefined) {
      questionListInfo.questionList && questionListInfo.questionList.forEach((question) => {
        question.isChecked = false;
      }, this);
      this.setState({ questionListInfo });
    }
    if (questionAddDialogArr) {
      this.setState({ questionAddDialogArr });
    }

    const { drillGroupId } = this.state;
    let questionDataListTmp = questionDataListTemp;
    if (questionAddDialogArr !== undefined
      && questionAddDialogArr.allDrillGroupIds
      && questionAddDialogArr.allDrillGroupIds.length > 0
      && drillGroupId !== undefined) {
      questionDataListTmp = questionAddDialogArr.byDrillGroupId[drillGroupId];
    }
    this.setState({ questionDataList: questionDataListTmp });
    this.setState({ questionDataListTemp: [] });
  }

  onChange(event, data) {
    if (data === undefined) {
      const { name, value, checked } = event.target;
      const index = event.nativeEvent.target.selectedIndex;
      const { drillGroupId } = event.target;
      if (name === 'skinSetSecernId') {
        const text = event.nativeEvent.target[index].text;
        this.setState({ ...this.state, ...{ skinSetName: text, skinSetSecernId: value } });
      } else if (name === 'groupPoint') {
        const groupPoint = value;
        const { questionAddDialogArr } = this.state;
        if (questionAddDialogArr.allDrillGroupIds && questionAddDialogArr.allDrillGroupIds.indexOf(drillGroupId) < 0) {
          questionAddDialogArr.allDrillGroupIds.push(drillGroupId);
        }
        questionAddDialogArr.byDrillGroupPoint[drillGroupId] = groupPoint;
        this.setState({ ...this.state, ...{ questionAddDialogArr } });
      }
      // STEP10.0.0 START
      else if (name === `questionSelectMethod${drillGroupId}`) {
        const questionSelectMethod = parseInt(value, 10);
        const { questionAddDialogArr } = this.state;
        if (questionAddDialogArr.allDrillGroupIds && questionAddDialogArr.allDrillGroupIds.indexOf(drillGroupId) < 0) {
          questionAddDialogArr.allDrillGroupIds.push(drillGroupId);
        }
        if (questionSelectMethod === ContentConstant.QUESTION_SELECT_METHOD.SPECIFIED_ORDER) {
          questionAddDialogArr.questionCount[drillGroupId] = '';
        }
        questionAddDialogArr.questionSelectMethod[drillGroupId] = questionSelectMethod;
        this.setState({ ...this.state, ...{ questionAddDialogArr } });
      }
      else if (name === `questionCount${drillGroupId}`) {
        const questionCount = parseInt(value, 10);
        const { questionAddDialogArr } = this.state;
        if (questionAddDialogArr.allDrillGroupIds && questionAddDialogArr.allDrillGroupIds.indexOf(drillGroupId) < 0) {
          questionAddDialogArr.allDrillGroupIds.push(drillGroupId);
        }
        questionAddDialogArr.questionCount[drillGroupId] = questionCount;
        this.setState({ ...this.state, ...{ questionAddDialogArr } });
      }
      // STEP10.0.0 END
      else {
        this.handleInputChange(name, value, checked);
      }
    } else {
      this.handleInputChange(event, data);
    }
  }

  handleInputChange(name, value, checked) {
    if (
      name === 'continuedFrStart' ||
      name === 'collectingLastMistakenIssue' ||
      name === 'collectingLastMistakenIssueEvenOnce' ||
      name === 'collectionQuestionsRegisteredInFavorites' ||
      name === 'restrictReanswer' ||
      name === 'attentionRelateSet' ||
      name === 'attentionHtmlUse' ||
      name === 'sankakuJudgeUseSet'
    ) {
      if (name === 'sankakuJudgeUseSet' && checked === false) {
        this.setState({
          ...this.state,
          ...{ [name]: checked },
          ...{ sankakuMarkSet: null },
        });
      } else if (name === 'attentionRelateSet' && checked === false) {
        this.setState({
          ...this.state,
          ...{ [name]: checked },
          ...{ attentionContent: '' },
          ...{ attentionHtmlUse: false },
          ...{ attentionHtmlFileName: '' },
        });
      } else {
        const state = { ...this.state, ...{ [name]: checked } };
        this.setState(state);
      }
    } else if (name === 'notUseHTML') {
      this.setState({ attentionHtmlUse: false });
    } else if (name === 'timeLimitNotUsed') {
      this.setState({
        ...this.state,
        ...{ limitTimeAdaptedTarget: ContentConstant.CONTENT_DRILL_OBJECT.DO_NOT_USE },
        ...{ drillLimitTime: '', limitTimeOverAction: 0, limitTimeCountForm: 1 }, // step6.3
      });
    } else if (name === 'timeLimitDrill') {
      this.setState({
        ...this.state,
        ...{ limitTimeAdaptedTarget: ContentConstant.CONTENT_DRILL_OBJECT.DRILL_PRIORITY },
      });
    } else if (name === 'timeLimitQuestion') {
      this.setState({
        ...this.state,
        ...{ limitTimeAdaptedTarget: ContentConstant.CONTENT_DRILL_OBJECT.QUESTION_PRIORITY },
        ...{ drillLimitTime: '' },
      });
    } else if (name === 'drillSecernId') {
      this.setState({ ...this.state, ...{ drillSecernId: value } });
    } else {
      this.setState({ ...this.state, ...{ [name]: value } });
    }
  }

  /**
    * Event button ok of delete confirm dialog clicked
    */
  onAddIdAuthorityOk() {
    this.setState({ showDialog: false });
  }

  deleteQuestion(drillGroupId, questionId) {
    this.props.dispatch(ContentAction.registerContentDrillDeleteQuestion(drillGroupId, questionId));
  }

  getSkinSetList() {
    this.props.dispatch(ContentAction.editContentDrillGetSkinSet());
  }

  handleOpenOrCloseAdvanceSettings() {
    this.setState({
      isAdvanceClosed: !this.state.isAdvanceClosed,
      advanceButtonText: this.state.isAdvanceClosed ? 'minute' : 'plus',
    });
  }
  fileChange(event) {
    if (event.target.files && event.target.files.length !== 0) {
      const attentionZipFile = event.target.files[0];
      this.setState({
        attentionZipFile,
        attentionHtmlFileName: attentionZipFile.name,
      });
    }
  }
  createParams(isAdaptiveDrill) {
    let param = {};
    if (isAdaptiveDrill) {
      param = this.getconfirmDataAdaptive();
    } else {
      param = this.getConfirmData();
    }
    return param;
  }
  getconfirmDataAdaptive(isAdaptiveDrill) {
    let param = {};
    const state = this.state;
    param = {
      drillInfo: {
        drillKind: parseInt(state.drillKind, 10),
        drillSecernId: state.drillSecernId || undefined,
        drillTitle: state.drillName || undefined,
        skinSetSecernId: state.skinSetSecernId,
        skinSetName: state.skinSetName,
        adaptiveDrillDecisionQuestionNumber: state.adaptiveDrillDecisionQuestionNumber > 0 ? parseInt(state.adaptiveDrillDecisionQuestionNumber, 10) : null,
        adaptiveDrillMaxQuestionNumber: state.adaptiveDrillMaxQuestionNumber > 0 ? parseInt(state.adaptiveDrillMaxQuestionNumber, 10) : null,
      },
    };
    return param;
  }
  getConfirmData() {
    const state = this.state;
    const startConditionTemp = [];
    startConditionTemp.push(0);// default
    if (this.state.continuedFrStart) {
      startConditionTemp.push(1);
    }
    if (this.state.collectingLastMistakenIssue) {
      startConditionTemp.push(2);
    }
    if (this.state.collectingLastMistakenIssueEvenOnce) {
      startConditionTemp.push(3);
    }
    if (this.state.collectionQuestionsRegisteredInFavorites) {
      startConditionTemp.push(4);
    }
    let againLimitTemp = '0';
    if (this.state.restrictReanswer) {
      againLimitTemp = '1_'.concat(state.reanswerTime);
    }
    const drillGroupArrayTemp = [];
    const { questionAddDialogArr } = state;
    if (questionAddDialogArr && questionAddDialogArr.allDrillGroupIds && questionAddDialogArr.allDrillGroupIds.length > 0) {
      questionAddDialogArr.allDrillGroupIds.map((drillGroupId, index) => {
        const drillGroupObject = {
          drillGroupId,
          drillQuestionIdScope: questionAddDialogArr.byDrillGroupId[drillGroupId] ? `0_${questionAddDialogArr.byDrillGroupId[drillGroupId].join('/')}` : '',
        };
        const groupPoint = questionAddDialogArr.byDrillGroupPoint && questionAddDialogArr.byDrillGroupPoint[drillGroupId];
        groupPoint && parseInt(state.markRule, 10) === 3 && (drillGroupObject.groupPoint = parseInt(groupPoint, 10));
        //STEP10.0.0 START
        const questionSelectMethod = questionAddDialogArr.questionSelectMethod[drillGroupId] ? questionAddDialogArr.questionSelectMethod[drillGroupId] : ContentConstant.QUESTION_SELECT_METHOD.SPECIFIED_ORDER;
        drillGroupObject.questionSelectMethod = parseInt(questionSelectMethod, 10);
        if (questionSelectMethod === ContentConstant.QUESTION_SELECT_METHOD.RANDOM) {
          let questionCount = questionAddDialogArr.questionCount[drillGroupId];
          drillGroupObject.questionCount = parseInt(questionCount, 10);
        }
        //STEP10.0.0 END
        drillGroupArrayTemp.push(drillGroupObject);
      });
    }
    const markRule = isNaN(state.markRule) ? null : parseInt(state.markRule, 10);
    const attentionRelateSet = state.attentionRelateSet ? 1 : 0;
    const attentionHtmlUse = attentionRelateSet && state.attentionHtmlUse ? 1 : 0;
    // #7190 START
    const limitTimeCountForm = !isNaN(state.limitTimeCountForm) && parseInt(state.limitTimeCountForm, 10);
    // #7190 END
    const param = {
      drillInfo: {
        drillKind: parseInt(state.drillKind, 10),
        drillSecernId: state.drillSecernId || undefined,
        drillTitle: state.drillName || undefined,
        startConditionList: startConditionTemp,
        againLimit: state.restrictReanswer && state.reanswerTime !== '' ? `1_${state.reanswerTime}` : '0',
        limitTimeAdaptedTarget: !isNaN(state.limitTimeAdaptedTarget) ? parseInt(state.limitTimeAdaptedTarget, 10) : 0,
        limitTimeOverAction: isNaN(state.limitTimeOverAction) ? 0 : parseInt(state.limitTimeOverAction, 10),
        // #7190 START
        limitTimeCountForm: limitTimeCountForm > 0 ? limitTimeCountForm : 1,
        // #7190 END
        drillLimitTime: isNaN(state.drillLimitTime) ? null : parseInt(state.drillLimitTime, 10),
        scoreForm: parseInt(state.scoreForm, 10),
        markRule,
        perfectPoint: markRule !== null && (markRule === 1 || markRule === 2) ? parseInt(state.perfectPoint, 10) : null,
        sankakuJudgeUseSet: state.sankakuJudgeUseSet && state.sankakuMarkSet !== '' ? 1 : 0,
        sankakuMarkSet: state.sankakuJudgeUseSet ? parseInt(state.sankakuMarkSet, 10) : null,
        skinSetSecernId: state.skinSetSecernId,
        attentionRelateSet,
        attentionHtmlUse: attentionHtmlUse ? 1 : 0,
        attentionContent: !attentionHtmlUse ? state.attentionContent : '',
        attentionZipFileName: attentionHtmlUse ? state.attentionHtmlFileName : '',
        drillGroupArray: drillGroupArrayTemp,
        skinSetName: state.skinSetName || (state.drillDetailInfo && state.drillDetailInfo.skinSetName),
      },
    };
    if (param.drillInfo.limitTimeAdaptedTarget === ContentConstant.CONTENT_DRILL_OBJECT.DO_NOT_USE) {
      param.drillInfo.limitTimeOverAction = 0;
      param.drillInfo.drillLimitTime = 0;
    }
    if (param.drillInfo.limitTimeAdaptedTarget === ContentConstant.CONTENT_DRILL_OBJECT.QUESTION_PRIORITY) {
      param.drillInfo.drillLimitTime = 0;
    }
    const attentionZipFile = state && state.attentionZipFile && attentionHtmlUse ?
    state.attentionZipFile : null;
    if (attentionZipFile) {
      param.attentionZipFile = state.attentionZipFile;
    }
    return param;
  }
  confirmDialogOK() {
    if (this.confirmData) {
      const updateData = this.confirmData;
      delete updateData.drillKind;
      delete updateData.drillInfo.skinSetName;
      this.props.dispatch(updateDrill(updateData));
    }
    this.setState({ showAddQuestionModal: false, showConfirmModal: false });
  }

  dialogCancel() {
    this.setState({ showAddQuestionModal: false, showConfirmModal: false });
  }

  onEditBtnClick() {
    if (this.validation()) {
      const isAdaptiveDrill = parseInt(this.state.drillKind, 10) == ContentConstant.DRILL_TYPE_ID.ADAPTIVE;
      this.confirmData = this.createParams(isAdaptiveDrill);
      this.setState({ showConfirmModal: true });
    }
  }

  onBackBtnClick() {
    this.props.history.goBack();
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  componentWillUnmount() {
    this.props.dispatch(ContentAction.resetContentDrillEditData());
    this.props.dispatch(ContentAction.resetDialogQuestion());
    this.props.dispatch(ContentAction.removeQuestionListDrill());
  }
  // -------
  openAddQuestionDialog(id) {
    const { register } = this.props;
    this.setState(
      {
        attributeOptions: register.attributeOptions,
        attributeText: register.attributeText,
        isClosed: true,
        buttonText: 'plus',
        number: NUM_ATTRIBUTE_QUESTION_SEARCH,
        showAddQuestionModal: true,
        drillGroupId: id,
      },
      () => {
        this.dialogSearch();
      },
    );
    this.props.dispatch(ContentQuestionAction.getAttributeQuestionList());
    this.props.dispatch(ContentAction.createValueAttributeItemDrill());
  }

  addQuestionDialogOK() {
    const { questionDataListTemp, drillGroupId } = this.state;
    this.props.dispatch(
      ContentAction.registerContentDrillAddQuestion(questionDataListTemp, drillGroupId),
    );
    this.setState({ showAddQuestionModal: false }, () => {
      let questionList = [];
      if (questionDataListTemp && questionDataListTemp.length) {
        questionList = questionDataListTemp;
      }
      this.props.dispatch(ContentAction.getQuestionListDrillDetail(questionList));
    });
  }

  handleDialogChange(event) {
    const { name, value } = event.target;
    const dialogQuestionInfo = { ...this.state.dialogQuestionInfo, ...{ [name]: value } };
    this.setState({ dialogQuestionInfo }, () => {
      this.props.dispatch(
        ContentAction.updateDialogSearchInfo(dialogQuestionInfo),
      );
    });
  }

  handleDialogCheckBox(id, event) {
    const { questionListInfo, questionDataListTemp } = this.state;
    for (const question of questionListInfo.questionList) {
      if (question.questionSecernId && question.questionSecernId === id) {
        question.isChecked = question.isChecked ? !question.isChecked : true;
        if (question.isChecked) {
          questionDataListTemp.push(id);
        } else {
          const index = questionDataListTemp.indexOf(id);
          if (index >= 0) {
            questionDataListTemp.splice(index, 1);
          }
        }
      }
    }
    this.setState({ questionListInfo });
  }

  handleCheckAll() {
    const { questionListInfo, questionDataListTemp } = this.state;
    const checkQuestionIdChecked = [];
    if (questionListInfo && questionListInfo.questionList && questionListInfo.questionList.length) {
      questionListInfo.questionList.map((question) => {
        const pos = questionDataListTemp.indexOf(question.questionSecernId);
        if (pos > -1) {
          checkQuestionIdChecked.push(pos);
        }
      });
      if (checkQuestionIdChecked.length === questionListInfo.questionList.length) {
        // uncheckAll
        questionListInfo.questionList.map((question) => {
          question.isChecked = false;
          const pos = questionDataListTemp.indexOf(question.questionSecernId);
          if (pos > -1) {
            questionDataListTemp.splice(pos, 1);
          }
          return null;
        });
        this.setState({ questionDataListTemp, questionListInfo });
        return;
      }
      // checkAll
      questionListInfo.questionList.map((question) => {
        question.isChecked = true;
        if (questionDataListTemp.indexOf(question.questionSecernId) < 0) {
          questionDataListTemp.unshift(question.questionSecernId);
        }
        return null;
      });
      this.setState({ questionDataListTemp, questionListInfo });
    }
  }


  dialogSearch(isSearch) {
    const dialogQuestionInfo = { ...this.state.dialogQuestionInfo };
    const questionAttributeId = this.state.attributeOptions;
    const eachQuestionAttributeName = this.state.attributeText;
    if (questionAttributeId || (questionAttributeId && eachQuestionAttributeName)) {
      const questionAttributeList = [];
      let attributeText = {};
      let attributeOptions = {};
      if (eachQuestionAttributeName) {
        attributeText = eachQuestionAttributeName;
      }
      if (questionAttributeId) {
        attributeOptions = questionAttributeId;
      }
      const attrArray = Object.keys(attributeOptions);
      attrArray.forEach((element) => {
        if (element && attributeOptions[element]) {
          const attrArrayObj = {
            questionAttributeId: attributeOptions[element],
            eachQuestionAttributeName: attributeText[element],
          };
          questionAttributeList.push(attrArrayObj);
        }
      });
      dialogQuestionInfo.questionAttributeList = questionAttributeList;
    }
    if (isSearch) {
      dialogQuestionInfo.startPosition = 0;
      dialogQuestionInfo.questionSortType = null;
      dialogQuestionInfo.ascendingDescendingSort = null;
    }
    this.setState({ isAllowShowSearchMessage: false, dialogQuestionInfo },
      () => {
        this.props.dispatch(
          ContentAction.updateDialogSearchInfo(dialogQuestionInfo),
        );
        this.props.dispatch(
          ContentQuestionAction.searchContent(dialogQuestionInfo),
        ).then(() => {
          this.setState({ isAllowShowSearchMessage: true });
        });
      },
    );
  }

  dialogQuestionCancel() {
    this.props.dispatch(
      ContentAction.resetDialogQuestionSearchInfo(),
    );
    this.setState({
      showAddQuestionModal: false,
    });
  }

  handleDialogSortState(row) {
    const { dialogQuestionInfo } = this.state;
    dialogQuestionInfo.ascendingDescendingSort = row.sortState;
    dialogQuestionInfo.questionSortType = row.sortBy;
    this.setState(
      {
        dialogQuestionInfo,
      },
      () => {
        this.dialogSearch();
      },
    );
  }

  /**
 * Handle event when user change page on dialog paging
 * @param page
 */
  getStartEndDialogData(startPosition) {
    const { dialogQuestionInfo } = this.state;
    dialogQuestionInfo.startPosition = startPosition;
    this.setState(
      {
        dialogQuestionInfo,
      },
      () => {
        this.dialogSearch();
      },
    );
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  removeAttributeSearch(name) {
    let attributeText = {};
    let attributeOptions = {};
    if (this.state && this.state.attributeText) {
      attributeText = { ...this.state.attributeText };
    }
    if (this.state && this.state.attributeOptions) {
      attributeOptions = { ...this.state.attributeOptions };
    }
    const attrArray = Object.keys(attributeOptions);
    const nameOptions = name.split('.').pop();
    const attrIndex = attrArray.indexOf(nameOptions);
    let number = this.state.number;
    attrArray.forEach((element) => {
      const indexElement = attrArray.indexOf(element);
      if (attrIndex === indexElement) {
        for (let i = attrIndex; i < number; i++) {
          const posDelete = attrArray[i];
          const posNext = attrArray[i + 1];
          attributeOptions[posDelete] = attributeOptions[posNext];
          attributeText[posDelete] = attributeText[posNext];
          // Reset value of last item to empty
          const lastElement = attrArray[NUM_ATTRIBUTE_QUESTION_SEARCH_MAX - 1];
          if (i === NUM_ATTRIBUTE_QUESTION_SEARCH_MAX - 1) {
            attributeOptions[lastElement] = '';
            attributeText[lastElement] = '';
          }
        }
      }
    });
    number--;
    this.setState({
      ...this.state,
      number,
      attributeOptions,
      attributeText,
    });
  }

  removeAllQuestionFromList(drillGroupId) {
    this.props.dispatch(ContentAction.removeAllQuestionFromList(drillGroupId));
  }

  removeGroup(drillGroupId) {
    this.props.dispatch(ContentAction.removeGroup(drillGroupId));
  }

  addGroup(drillGroupId) {
    this.props.dispatch(ContentAction.addGroup(drillGroupId));
  }

  saveActiveTabMenu() {
    this.props.dispatch(saveActiveTabMenu(Path.CONTENT_QUESTION_LIST));
  }
  // STEP9.0.0 START
  openSortDrillQuestionDialog(groupIndex, drillGroupId) {
    this.setState({
      showContentDrillQuestionSortDiaLog: true,
    });
    const { dispatch } = this.props;
    dispatch(getDrillQuestionListForSort(groupIndex, drillGroupId));
  }

  hideSortDrillQuestionDialog() {
    this.setState({
      showContentDrillQuestionSortDiaLog: false,
    });
  }
  // STEP9.0.0 END

  render() {
    const { questionDataList, editSuccessfull, isAllowShowSearchMessage, questionAddDialogArr } = this.state;
    const { authCd, institutionId } = this.props;
    const isAdaptiveDrill = parseInt(this.state.drillKind, 10) == ContentConstant.DRILL_TYPE_ID.ADAPTIVE;
    this.refsToValidate = [];
    if (editSuccessfull) {
      this.props.history.push(CONTENT_DRILL_LIST);
    }
    const { questionDrillList, questionDrillListArr } = this.props.content;
    return (
      <Form className='form-horizontal'>
        <Col sm={12} className="margin-bottom-10">
          <CustomLink
            className="margin-right-7 url-list"
            to={Path.CONTENT_DRILL_LIST}
            text="一覧に戻る"
            icon="bi bi-chevron-left"
          />
          <Header name="ドリルの編集" />
          <ContentDrillEdit
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            handleChange={this.onChange}
            handleDeleteQuestion={this.deleteQuestion}
            handleEditQuestion={this.openAddQuestionDialog}
            questionDataList={questionDataList}
            drillKind={this.state.drillKind}
            scoreForm={this.state.scoreForm}
            skinSetSecernId={this.state.skinSetSecernId}
            skinSetList={this.state.skinSetList}
            addQuestionBtn={this.openAddQuestionDialog}
            // STEP9.0.0 START
            openSortDrillQuestionDialog={this.openSortDrillQuestionDialog}
            // STEP9.0.0 END
            continuedFrStart={this.state.continuedFrStart}
            collectingLastMistakenIssue={this.state.collectingLastMistakenIssue}
            collectingLastMistakenIssueEvenOnce={this.state.collectingLastMistakenIssueEvenOnce}
            collectionQuestionsRegisteredInFavorites={
            this.state.collectionQuestionsRegisteredInFavorites
          }
          restrictReanswer={this.state.restrictReanswer}
          drillSecernId={this.state.drillSecernId}
          drillName={this.state.drillName}
          isEdit
          isAdaptiveDrill={isAdaptiveDrill}
          reanswerTime={this.state.reanswerTime}
          adaptiveDrillMaxQuestionNumber={this.state.adaptiveDrillMaxQuestionNumber}
          adaptiveDrillDecisionQuestionNumber={this.state.adaptiveDrillDecisionQuestionNumber}
            questionDrillList={questionDrillList}
            questionDrillListArr={questionDrillListArr}
            removeAllQuestionFromList={this.removeAllQuestionFromList}
            addGroup={this.addGroup}
            removeGroup={this.removeGroup}
            questionAddDialogArr={questionAddDialogArr}
            markRule={this.state.markRule}
          />
          {!isAdaptiveDrill && <ContentDrillEditAdvanced
            handleChange={this.onChange}
            openOrCloseAdvanceSettings={this.handleOpenOrCloseAdvanceSettings}
            buttonText={this.state.advanceButtonText}
            isClosed={this.state.isAdvanceClosed}
            limitTimeAdaptedTarget={this.state.limitTimeAdaptedTarget}
            limitTimeOverAction={this.state.limitTimeOverAction}
            limitTimeCountForm={this.state.limitTimeCountForm}
            markRule={this.state.markRule}
            sankakuJudgeUseSet={this.state.sankakuJudgeUseSet}
            attentionRelateSet={this.state.attentionRelateSet}
            attentionHtmlUse={this.state.attentionHtmlUse}
            handleFileChange={this.fileChange}
            attentionHtmlFileName={this.state.attentionHtmlFileName}
            note={this.state.remark}
            drillLimitTime={this.state.drillLimitTime}
            perfectPoint={this.state.perfectPoint}
            sankakuMarkSet={this.state.sankakuMarkSet}
            attentionContent={this.state.attentionContent}
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
          />}
          <Col sm={12} className="text-center margin-top-20 margin-bottom-10">
            <Button
              variant="default"
              className="btn btn-default btn-96 margin-right-10"
              onClick={this.onBackBtnClick}
            >
            キャンセル
            </Button>
            <Button variant="primary" className="btn-96 text-center" onClick={this.onEditBtnClick}>
              登録
            </Button>
          </Col>
          <AddQuestionDialog
            showModal={this.state.showAddQuestionModal}
            handleChange={this.handleDialogChange}
            handleCheckbox={this.handleDialogCheckBox}
            handleDialogSearch={this.dialogSearch}
            dialogGetStartEndData={this.getStartEndDialogData}
            handleSearchSortState={this.handleDialogSortState}
            onDialogCancel={this.dialogQuestionCancel}
            onDialogOK={this.addQuestionDialogOK}
            startPosition={this.state.dialogQuestionInfo ? this.state.dialogQuestionInfo.startPosition : 0}
            recordNum={this.state.questionListInfo ? this.state.questionListInfo.recordNum : 0}
            existQuestionList={this.state.questionDataList}
            dialogSearchResult={this.state.questionListInfo}
            questionDataListTemp={this.state.questionDataListTemp}
            isEdit={false}
            {...this.state.dialogQuestionInfo}
            dismissMessage={this.dismissMessage}
            isAllowShowSearchMessage={isAllowShowSearchMessage}
            openPreviewEachQuestionAttribute={this.openPreviewEachQuestionAttribute}
            attributeListData={this.props.attributeListData}
            handleChangeOption={this.handleChangeOption}
            attributeOptions={this.state.attributeOptions}
            openOrCloseAttributeArea={this.openOrCloseAttributeArea}
            isClosed={this.state.isClosed}
            buttonText={this.state.buttonText}
            handleChangeTextAttribute={this.handleChangeTextAttribute}
            attributeText={this.state.attributeText}
            addAttribute={this.addAttribute}
            number={this.state.number}
            removeAttributeSearch={this.removeAttributeSearch}
            authCd={authCd}
            institutionId={institutionId}
            handleCheckAll={this.handleCheckAll}
            saveActiveTabMenu={this.saveActiveTabMenu}
          />
          {/* STEP9.0.0 START */}
          <ContentDrillQuestionSortDiaLog
            showModal={this.state.showContentDrillQuestionSortDiaLog}
            onDialogCancel={this.hideSortDrillQuestionDialog}
          />
          {/* STEP9.0.0 END */}
          <ContentDrillEditConfirmDialog
            onDialogOK={this.confirmDialogOK}
            onDialogCancel={this.dialogCancel}
            showModal={this.state.showConfirmModal}
            drillDetail={this.createParams(isAdaptiveDrill)}
            questionDrillList={questionDrillList}
            questionDrillListArr={questionDrillListArr}
            markRule={this.state.markRule}
          />
        </Col>
      </Form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authedUser } = state.authed;
  const institutionId = (authedUser && authedUser.institutionId) ? authedUser.institutionId : '';
  const authCd = (authedUser && authedUser.authCd) ? authedUser.authCd : '';
  return {
    ...{
      drillDetailInfo: state.drillDetailInfo,
      content: state.content,
      edit: state.content.edit,
      editSuccessfull: state.content.drillDetailInfoOK,
      questionListInfo: state.question ? state.question.questionListInfo : {},
      attributeListData: state.question ? state.question.attributeListData : {},
      register: state.content ? state.content.register : {},
    },
    authCd,
    institutionId,
  };
};

export default connect(mapStateToProps)(ContentDrillEditionContainer);
